import React from 'react';
import Navigation from '../components/layout/Navigation';
import { motion } from 'framer-motion';

const AboutPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation isAuthenticated={false} />
      
      <section className="py-24 bg-gradient-to-b from-rowing-gray-50 to-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <h1 className="text-5xl font-display font-bold text-rowing-navy">
              About GLYYD
            </h1>
            <p className="mt-6 text-xl text-rowing-gray-600">
              Built by rowers who understand the journey
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mt-16 prose prose-lg mx-auto"
          >
            <p className="text-rowing-gray-700">
              GLYYD was founded by former collegiate rowers who experienced firsthand the challenges 
              of the recruitment process. We believe every aspiring student-athlete deserves access 
              to the tools and information needed to find their perfect college match.
            </p>
            
            <h2 className="text-2xl font-display font-semibold text-rowing-navy mt-12">Our Mission</h2>
            <p className="text-rowing-gray-700">
              To democratize the college rowing recruitment process by providing a comprehensive, 
              user-friendly platform that connects student-athletes with rowing programs across the country.
            </p>

            <h2 className="text-2xl font-display font-semibold text-rowing-navy mt-12">Why GLYYD?</h2>
            <ul className="space-y-4 text-rowing-gray-700">
              <li>• Comprehensive database of 200+ rowing programs</li>
              <li>• Direct connections with college coaches</li>
              <li>• Performance tracking and analytics</li>
              <li>• Academic and athletic matching</li>
              <li>• Parent involvement tools</li>
            </ul>

            <div className="mt-16 bg-rowing-blue bg-opacity-10 p-8 rounded-lg">
              <p className="text-rowing-navy font-semibold text-center">
                Join thousands of student-athletes who have found their perfect college rowing program through GLYYD.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;